import { ListItemIcon, ListItemText, Skeleton } from '@mui/material';

import { Or2ListItem } from '@/components/data-display/Or2ListItem';

interface MultiGroupFilterOptionSkeletonProps {
  nameWidth: string;
}

/**
 * Placeholder for a group the filter is fetching, mirroring the avatar, name
 * and checkbox of MultiGroupFilterGroupOption so the list does not jump as
 * options arrive.
 */
export const MultiGroupFilterOptionSkeleton = ({
  nameWidth,
}: MultiGroupFilterOptionSkeletonProps) => {
  return (
    <Or2ListItem
      dense
      secondaryAction={
        <Skeleton variant="rounded" width={18} height={18} animation="wave" />
      }
    >
      <ListItemIcon>
        <Skeleton variant="circular" width={32} height={32} animation="wave" />
      </ListItemIcon>
      <ListItemText
        primary={<Skeleton variant="text" width={nameWidth} animation="wave" />}
        slotProps={{ primary: { variant: 'subtitle1' } }}
      />
    </Or2ListItem>
  );
};
